exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".daterangepicker .drp-buttons .btn {\n  border-radius: 5px;\n  margin-left: 8px;\n  font-size: 10pt;\n  font-weight: bold;\n  padding: 8px;\n  margin-bottom: 6px;\n}\n.daterangepicker .drp-buttons .btn-primary {\n  background: #39acb5 !important;\n  color: #fff !important;\n  border: none !important;\n}\n.daterangepicker .drp-buttons .cancelBtn {\n  background: #b72221 !important;\n  color: #fff !important;\n  border: none !important;\n}\n.daterangepicker td.active {\n  background: #39acb5 !important;\n}\n", ""]);

// exports
